"use client";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";


const stats = [
    { value: "2.8k+", label: "prs reviewed" },
    { value: "150+", label: "active repos" },
    { value: "< 3s", label: "avg response" },
    { value: "99.2%", label: "uptime" },
];

export function GithubShowcase() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <section ref={ref} className="py-24 px-4 bg-background">
            <div className="container mx-auto max-w-4xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
                        trusted by developers
                    </h2>
                    <p className="text-muted-foreground text-lg">
                        teams using burg ai ship faster with fewer bugs
                    </p>
                </motion.div>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={stat.label}
                            initial={{ opacity: 0, y: 20 }}
                            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="text-center p-6 rounded-xl border border-border bg-card"
                        >
                            <div className="text-3xl md:text-4xl font-bold mb-2">{stat.value}</div>
                            <div className="text-sm text-muted-foreground">{stat.label}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
